import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';

export interface ChainItem {
  label: string;
  value: number;
}

export interface PreviousChainDisplayProps {
  chain: ChainItem[];
  onClear: () => void;
}

const PreviousChainDisplay: React.FC<PreviousChainDisplayProps> = ({ chain, onClear }) => {
  const { t } = useTranslation();

  if (!chain || chain.length === 0) {
    return null;
  }

  const chainText = chain.map(item => item.label).join(' > ');

  return (
    <Alert
      message={t('previous_selection')}
      description={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#666' }}>{chainText}</span>
          <Button type="link" size="small" onClick={onClear} style={{ marginLeft: 16 }}>
            {t('clear')}
          </Button>
        </div>
      }
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
    />
  );
};

export default PreviousChainDisplay;
